module.exports = new __parcel__URL__("48671_sq.fb97c416.jpg").toString();